﻿let $ = require('jquery');


//let eventsCalendar = require('./EventsCalendar/eventsCalendar.js');
let BrowserSession = require('./BrowserSession.js');
let EventsList = require('./EventsList/EventsList.js');
let videoList = require('./VideosList/videoList.js');
let FullDonationForm = require('./FullDonationForm/FullDonationForm.js');
let Menu = require('./Menu/menu.js');
let login = require('./LoginScript');
let Subscribe = require('./RegisterScript');
let ClicksTracking = require('./Tracking/ClicksTracking');

//TODO modify to use contructor based initialization
Subscribe();

let Donate = require('./Donate/Donate'); 
let Slideshow = require('./Slideshow');
let Description = require('./Description/Description');
let Separator = require('./Separator/Separator');
let FeaturedSponsors = require('./FeaturedSponsors/FeaturedSponsors');
let SearchBox = require('./NewsSearch/SearchBox');
let ExpandableList = require('./ExpandableList');
let EventsCalendar = require('./EventsCalendar/EventsCalendar');
let Dropdown = require('./Dropdown/Dropdown');
let RegionSearchBox = require('./RegionSearchBox/RegionSearchBox');
let HorizontalGallery = require('./HorizontalGallery');
let SpeakersRequest = require('./SpeakersRequest/SpeakersRequest');
let Sizer = require('./Sizer');
let SizerBreakpoint = require('./SizerBreakpoint');
let RegionsFilter = require('./RegionsFilter/RegionsFilter');
let Iframe = require('./Iframe/Iframe');
let StickyLogotype = require('./StickyLogotype');
let LuminateSessionSync = require('./LuminateSessionSync/LuminateSessionSync');
let GeneralSearch = require('./GeneralSearch/GeneralSearch');
let SmugmugEventGallery = require('./SmugmugEventGallery/SmugmugEventGallery');
let Tracker = require('./Tracking/Tracker');
let SlickSlider = require('./SlickSlider');

let donationWidgetSelector = '.jnf-widget.jnf-widget-donate:not(.jnf-widget-is-designer)';
let slideshowWidgetSelector = '.jnf-widget.jnf-widget-slideshow';
let slideshowLeadersWidgetSelector = '.jnf-widget.jnf-widget-slideshow-leaders';
let descriptionWidgetSelector = '.jnf-widget.jnf-widget-description';
let separatorWidgetSelector = '.jnf-widget.jnf-widget-separator:not(.jnf-widget-separator-use-page-breakpoints)';
let featuredSponsorsSelector = '.jnf-widget.jnf-widget-featured-sponsors';
let searchBoxSelector = '.jnf-widget.search-box-widget';
let newsWidgetSelector = '.custom-news-wrapper';
let professionalStaffWidgetSelection = '.jnf-widget.professional-staff';
let speakersFilterWidgetSelector = '.jnf-widget.speakers-filter';
let menuDropdownWidgetSelector = '.jnf-widget-dropdown .topic-select.jnf-dropdown.jnf-menu-dropdown';
let regionSearchBoxWidgetSelector = '.jnf-widget.regions-search-widget';
let speakersRequestSelector = '.speakers-request-form-wrapper';
let featuredVideoWidgetSelector = '.jnf-widget.featured-video';
let fullDonationFormWidgetSelector = '.full-donation-form';
let regionsFilterWidgetSelector = '.jnf-widget.regions-filter';
let eventsListWidgetSelector = '.jnf-widget.events-list';
let eventRegistrationFormWidgetSelector = '.jnf-widget.event-registration-form';
let menu3WidgetSelector = ".jnf-widget.jnf-widget-menu-3-menu";
let titleSelector = '.jnf-widget-title';
let stickyLogotypeSelector = '.mobile-logotype-banner';
let honoreeWidgetSelector = '.jnf-widget.honoree';
let luminateSessionSyncWidgetSelector = '.jnf-widget.luminate-session-sync';
let generalSearchWidgetSelector = '.jnf-widget.general-search-box';
let iframeWidgetSelector = '.jnf-widget.iframe-widget';
let gallerySelector = '.jnf-smugmug-event-gallery';
let smugmugEventGallery = '.jnf-smugmug-event-gallery';
let smugmugFullGallery = '.jnf-smugmug-gallery';

$(donationWidgetSelector).each(function (widgetElementIndex, widgetElement) {

    new Donate({
        element: widgetElement,
        submitUrl: $(widgetElement).attr('data-submit-url'),
        valueKey: 'set.Value',
        levelKey: 'set.DonationLevel'
    });
});
$(slideshowWidgetSelector).each(function (widgetElementIndex, widgetElement) {

    let slideLinks = $(this).find('.jnf-widget-slideshow-details-list a');
    let slideLinksForImages = $(this).find('.jnf-widget-slideshow-photo-container-list a');
  
    slideLinks.each(function (index) {
        let slidesDescription = $(this).find('+ .jnf-widget-slideshow-details-list-item');
        $(this).html(slidesDescription);
    });
    slideLinksForImages.each(function (index) {
        let slidesImages = $(this).find('+ .jnf-widget-slideshow-photo-container-list-item');
        $(this).html(slidesImages);
    });

});

$(slideshowWidgetSelector).each(function (widgetElementIndex, widgetElement) {

    new Slideshow({
        element: widgetElement
    });
});



$(slideshowLeadersWidgetSelector).each(function (widgetElementIndex, widgetElement) {

    new Slideshow({
        element: widgetElement
    });
});

jQuery.fn.swapWith = function (to) {
    return this.each(function () {
        let thisPrev = $(this).prev();
        let toPrev = $(to).prev();

        $(this).insertAfter(toPrev);
        $(to).insertAfter(thisPrev);
    });
};

let els = $(descriptionWidgetSelector).filter('.jnf-widget-description-template-4');
let els2 = $(descriptionWidgetSelector).filter('.jnf-widget-description-template-featured-donors');
let swaps = Math.ceil(els.length/3);

if ($("#hsi-body").length === 0){ //ONLY run "random sort" on JNF, NOT AMHSI site
    for (; swaps > 0; swaps--) {
        let s1 = Math.floor(Math.random()*els.length);
        let s2 = Math.floor(Math.random() * els.length);

        if (s1 !== s2) {
            els.eq(s1).swapWith(els.eq(s2));
        }
    }
}


els = $(descriptionWidgetSelector).filter('.jnf-widget-description-template-4');

els.each(function (index, el) {

    if (index % 2 !== 0) {
        $(el).addClass('jnf-widget-description-template-4-even');
    }
});

els2.each(function (index, el) {

    if (index % 2 !== 0) {
        $(el).addClass('jnf-widget-description-template-featured-donors-even');
    }
});

$(descriptionWidgetSelector).each(function (widgetElementIndex, widgetElement) {

    new Description({
        element: widgetElement
    });
});

$(separatorWidgetSelector).each(function (widgetElementIndex, widgetElement) {

    new Separator({
        element: widgetElement
    });
});

$(featuredSponsorsSelector).each(function (widgetElementIndex, widgetElement) {

    new FeaturedSponsors({
        element: widgetElement
    });
});

$(searchBoxSelector).each(function (widgetElementIndex, widgetElement) {

    new SearchBox({
        element: $(widgetElement),
        input: $(widgetElement).find('.query-input'),
        searchButton: $(widgetElement).find('.search-button')
    });
});

$(newsWidgetSelector).each(function (widgetElementIndex, widgetElement) {
    new ExpandableList({
        loadMoreElement: $(widgetElement).find('.load-more-link'),
        elements: $(widgetElement).find('.jnf-news-container').children(),
        onListExpanded: () => $(widgetElement).find('.news-archive-link').show()
    });
});

$(professionalStaffWidgetSelection).each(function (widgetElementIndex, widgetElement) {
    new ExpandableList({
        loadMoreElement: $(widgetElement).find('.load-more-link'),
        elements: $(widgetElement).find('.professional-staff-list').children()
    });
});

$('.region-select').each(function (widgetElementIndex, widgetElement) {
    new Dropdown({
        element: $(widgetElement),
        menuElement: $(widgetElement).find('.jnf-dropdown-menu'),
        windowElement: $(window)
    });
});

$('#calendar').each(function (widgetElementIndex, widgetElement) {
    new EventsCalendar($(widgetElement));
});

$(speakersFilterWidgetSelector).each(function (widgetElementIndex, widgetElement) {
    $(widgetElement).find('.jnf-dropdown').each(function (index, dropdownElement) {

        new Dropdown({
            element: $(dropdownElement),
            menuElement: $(dropdownElement).find('.jnf-dropdown-menu'),
            windowElement: $(window)
        });
    })
});

$(menuDropdownWidgetSelector).each(function (widgetElementIndex, widgetElement) {
    new Dropdown({
        element: $(widgetElement),
        menuElement: $(widgetElement).find('.jnf-dropdown-menu'),
        windowElement: $(window)
    });
});

$(regionSearchBoxWidgetSelector).each(function (widgetElementIndex, widgetElement) {
    new RegionSearchBox({
        searchButton: $(widgetElement).find('.search-button'),
        queryInput: $(widgetElement).find('.query-input'),
        serverRoot: $(widgetElement).data('server-root'),
        defaultUrl: $(widgetElement).data('default-url')
    });
});

$(speakersRequestSelector).each(function (widgetElementIndex, widgetElement) {
    new SpeakersRequest({
        element: $(widgetElement),
        submitButton: $(widgetElement).find('.orange-submit'),
        resetButton: $(widgetElement).find('.cancel')
    });
});

$(featuredVideoWidgetSelector).each(function (widgetElementIndex, widgetElement) {
    new SizerBreakpoint({
        element: $(widgetElement)
    });

    new HorizontalGallery({
        element: $(widgetElement),
        arrowLeftSelector: '.arrow-container.arrow-container-left',
        arrowRightSelector: '.arrow-container.arrow-container-right',
        listSelector: 'ul',
        listElementSelector: 'li',
        arrowVisibleClass: 'visible'
    });
});

$(fullDonationFormWidgetSelector).each(function (widgetElementIndex, widgetElement) {
    new FullDonationForm({
        form: $(widgetElement)
    });
});

$(eventsListWidgetSelector).each(function (widgetElementIndex, widgetElement) {
    new EventsList({
        listElement: $(widgetElement).find('ul'),
        listType: $(widgetElement).data('list-type'),
        upcomingEventsCount: $(widgetElement).data('upcoming-events-count'),
        upcomingEventsRegion: $(widgetElement).data('region-name')
    });
});

// Regions filter widget should be initialized after events list and calendar widgets
$(regionsFilterWidgetSelector).each(function (widgetElementIndex, widgetElement) {
    new RegionsFilter({
        listElement: $(widgetElement).find('ul'),
        userRegionCode: $(widgetElement).data('user-region-code')
    });
});

$(eventRegistrationFormWidgetSelector).each(function (widgetElementIndex, widgetElement) {
    new Iframe({
        element: $(widgetElement)
    });
});

$(menu3WidgetSelector).each(function (widgetElementIndex, widgetElement) {
    new SizerBreakpoint({
        element: $(widgetElement)
    });
});

$(titleSelector).each(function (widgetElementIndex, widgetElement) {
    let titleLink = $(this).find('a');
    let titleText = $(this).find('h1');
    if (titleLink.length > 0) {
        titleLink.html(titleText);

        let eventName = widgetElement.dataset.trackingEvent;
        if (eventName) {
            titleLink.on('click', () => Tracker.trackGenericEvent(eventName, {
                page: window.location.pathname
            }));
        }
    }
});

if (!BrowserSession()) {
    $(stickyLogotypeSelector).each(function (widgetElementIndex, widgetElement) {

        new StickyLogotype({
            element: $(widgetElement),
            inactiveSession: true
        });
    });
}
$(honoreeWidgetSelector).each(function (widgetElementIndex, widgetElement) {
    new SizerBreakpoint({
        element: $(widgetElement)
    })
});

$(luminateSessionSyncWidgetSelector).each(function (widgetElementIndex, widgetElement) {
    new LuminateSessionSync({
        isUserSignedIn: $(widgetElement).data('isSignedIn') === 'True'
    });
});

$(generalSearchWidgetSelector).each(function (widgetElementIndex, widgetElement) {
    new GeneralSearch({
        element: $(widgetElement),
        container: $(widgetElement).find('.container'),
        input: $(widgetElement).find('.query-input'),
        button: $(widgetElement).find('.icon'),
        closeButton: $(widgetElement).find('.close-button')
    });
});

$(iframeWidgetSelector).each(function (widgetElementIndex, widgetElement) {
    new Iframe({
        element: $(widgetElement),
    });
});

$(gallerySelector).each(function (widgetElementIndex, widgetElement) {
    new SizerBreakpoint({
        element: $(widgetElement),
        extraSizes: [{ maxWidth: 360, cssClass: 'sizer-3-columns' }, { maxWidth: 620, cssClass: 'sizer-2-columns' }, { maxWidth: 1000, cssClass: 'sizer-1-columns' }]
    });
});

$(smugmugEventGallery).each(function (widgetElementIndex, widgetElement) {
    new SmugmugEventGallery({
        element: $(widgetElement),
        shareButton: $(widgetElement).find('.share-button'),
        sharePopup: $(widgetElement).find('.jnf-share-popup')
    });
});

$(smugmugFullGallery).each(function (widgetElementIndex, widgetElement) {
    new SmugmugEventGallery({
        element: $(widgetElement),
        shareButton: $(widgetElement).find('.share-button'),
        sharePopup: $(widgetElement).find('.jnf-share-popup')
    });
});


ClicksTracking();